// extracted by mini-css-extract-plugin
var _1 = "InstallInterstitial-module__button___taYEd";
var _2 = "InstallInterstitial-module__close___AJTm6";
var _3 = "InstallInterstitial-module__container___hb7AC";
var _4 = "InstallInterstitial-module__contentContainer___jesPI";
var _5 = "InstallInterstitial-module__divider___kvVbF";
var _6 = "InstallInterstitial-module__header___YFP3q";
var _7 = "InstallInterstitial-module__imageContainer___KXgxi";
var _8 = "InstallInterstitial-module__logoAndRatingContainer___K2DC6";
var _9 = "InstallInterstitial-module__nameAndRatingContainer___qKZlh";
var _a = "InstallInterstitial-module__phone___Wrlu6";
var _b = "InstallInterstitial-module__ratingContainer___KguoM";
var _c = "InstallInterstitial-module__texture___bF6Kn";
export { _1 as "button", _2 as "close", _3 as "container", _4 as "contentContainer", _5 as "divider", _6 as "header", _7 as "imageContainer", _8 as "logoAndRatingContainer", _9 as "nameAndRatingContainer", _a as "phone", _b as "ratingContainer", _c as "texture" }
